function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import find from 'lodash/find';
import get from 'lodash/get';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App from 'modules/App';
import * as constants from '../../../constants';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import JoinForm from './JoinForm';
var _React_PureComponent;
class JoinModal extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        const { openModalId, isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.setHasBeenSent();
            return;
        }
        if (prevProps.openModalId !== openModalId) {
            if (openModalId) this.setOrganization();
            else this.resetState();
        }
    }
    setOrganization() {
        const { organizationUID } = this.props;
        const organization = find(this.props.organizations, {
            organizationUID
        }) || {};
        this.setState({
            organization
        });
    }
    setHasBeenSent() {
        this.setState({
            hasBeenSent: true
        });
    }
    resetState() {
        this.setState({
            organization: {},
            hasBeenSent: false
        });
    }
    renderText() {
        const organizationName = /*#__PURE__*/ _jsx("b", {
            children: get(this.state.organization, 'name')
        });
        const message = this.state.hasBeenSent ? messages.infos.joinOrganizationSent : messages.intros.joinOrganization;
        return /*#__PURE__*/ _jsx("p", {
            className: "text--paragraph mb-7",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, message), {
                values: {
                    organizationName
                }
            }))
        });
    }
    renderContent() {
        if (this.state.hasBeenSent) {
            return /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: App.messages.buttons.close,
                className: "btn--block btn--filled",
                onClick: this.props.onClose
            });
        }
        return /*#__PURE__*/ _jsx(JoinForm, {
            organization: this.state.organization,
            isInProgress: this.props.isInProgress,
            hasErrors: this.props.hasErrors,
            onClose: this.props.onClose
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.JOIN_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: messages.headers.joinOrganization,
            isInProgress: this.props.isInProgress,
            onClose: this.props.onClose,
            children: [
                this.renderText(),
                this.renderContent()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            organization: null,
            hasBeenSent: false
        };
    }
}
_define_property(JoinModal, "propTypes", {
    // Explicit props
    organizationUID: PropTypes.string,
    organizations: PropTypes.arrayOf(shapes.organization),
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Implicit props
    openModalId: PropTypes.string,
    // Implicit actions
    onClose: PropTypes.func
});
const mapStateToProps = (state)=>({
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onClose: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedJoinModal = connect(mapStateToProps, mapDispatchToProps)(JoinModal);
export default ConnectedJoinModal;
